// extracted by mini-css-extract-plugin
export default {"svgLg":"sprites_svgLg__SWVXs","svgLg__icon":"sprites_svgLg__icon__ka5l5","svgLg__iconWhite":"sprites_svgLg__iconWhite__NgxVH","svgBig":"sprites_svgBig__GPrme"};